// extracted by mini-css-extract-plugin
export default {"text":"ErrorTreatment_text__2NLl8","button":"ErrorTreatment_button__GYCvR"};